import React from "react";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Paper,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Draggable from "react-draggable";
import theme from "theme";
import SC from "./style";
import { useMediaQuery } from "@mui/material";
import InnoIcons from "@InnoIcons/";

const PaperComponent = (props) => {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
      bounds="parent"
    >
      <Paper {...props} />
    </Draggable>
  );
};

const BulkActionView = (props) => {
  const {
    title = "",
    openModal = false,
    handleCloseModal = () => console.error("handleCloseModal props missing"),
    renderBodyConditionally = () =>
      console.error("renderBodyConditionally props missing"),
    padding,
    fontSize,
    closeIcon = false,
    sx,
    isAdd = "400px",
    borderRadius,
    leftPanel,
    leftPanelCollapsed = false,
    showSummaryPanel = false,
    handleCollapsedSummaryBack = () => {},
    leftPanelCollapsedButton = () => {},
    leftPanelWidth,
    horizontalWidth = "550px",
    closeLoading = false,
  } = props;

  const isMobile = useMediaQuery("(max-width:768px)");

  return (
    <>
      {SC.GlobalStyles}
      <Dialog
        open={openModal}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        onClose={(event, reason) => {
          if (closeLoading) return;
          if (reason !== "backdropClick") {
            handleCloseModal();
          }
        }}
        PaperProps={{
          sx: {
            width: isMobile ? "100vw" : "fit-content",
            minWidth: isMobile ? "100vw" : isAdd,
            maxWidth: "90vw",
            height: isMobile ? "100vh" : "auto",
            // maxHeight: "100vh",
            borderRadius: isMobile ? 0 : borderRadius,
            // overflow: "hidden",
            overflow: "visible",
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <div>{leftPanelCollapsed && leftPanelCollapsedButton}</div>
        <div
          style={{
            display: "flex",
            flex: 1,
            overflow: "hidden",
            minHeight: 0,
          }}
        >
          {showSummaryPanel && (
            <div
              style={{
                position: isMobile ? "absolute" : "relative",
                inset: isMobile ? 0 : "auto",
                width: isMobile ? "100%" : leftPanelWidth,
                background: "#fff",
                zIndex: 20,
                borderRight: !isMobile
                  ? `1px solid ${theme.colors.bordertask}`
                  : "none",
                borderRadius: isMobile ? 0 : "5px 0 0 5px",
              }}
            >
              {leftPanel}
            </div>
          )}

          {/* <div> */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              flex: 1,
              minHeight: 0,
              overflow: "hidden",
            }}
          >
            <DialogTitle
              style={{
                cursor: "move",
                background: `${theme.gradient.themeGradient}`,
                alignItems: "center",
                display: "flex",
                position: "sticky",
                top: 0,
                zIndex: 10,
                borderRadius: "4px 4px 0px 0px",
                flexShrink: 0,
              }}
              id="draggable-dialog-title"
            >
              <SC.DialogTitle padding={padding} fontSize={fontSize}>
                {title || "Text"}
              </SC.DialogTitle>

              {!closeIcon && (
                <IconButton
                  edge="end"
                  color="inherit"
                  onClick={closeLoading ? undefined : handleCloseModal}
                  aria-label="close"
                  disabled={closeLoading}
                  sx={{ position: "absolute", right: 12, color: "white" }}
                >
                  {closeLoading ? (
                    <CircularProgress size={18} sx={{ color: "white" }} />
                  ) : (
                    <CloseIcon />
                  )}
                </IconButton>
              )}
            </DialogTitle>

            <DialogContent
              sx={{
                ...sx,
                width: showSummaryPanel ? "100%" : horizontalWidth,
                maxWidth: showSummaryPanel ? "100%" : horizontalWidth,
                minHeight: isMobile ? "200px" : "160px",
                overflowY: "auto",
                overflowX: "hidden",
                padding: isMobile ? "12px" : "16px",
                boxSizing: "border-box",
                flex: 1,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <SC.DialogContent>{renderBodyConditionally()}</SC.DialogContent>
            </DialogContent>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default BulkActionView;
